module.exports = __webpack_public_path__ + "static/media/linkedin.aff00574.svg";